import * as React from 'react';
import type { SVGProps } from 'react';
const SvgVk = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="Layer 1"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    color="currentColor"
    {...props}
  >
    <path d="M15.073 2H8.938C3.332 2 2 3.333 2 8.927v6.136C2 20.667 3.323 22 8.927 22h6.136C20.667 22 22 20.677 22 15.073V8.938C22 3.332 20.677 2 15.073 2m3.073 14.27h-1.459c-.552 0-.718-.447-1.708-1.437-.864-.833-1.229-.937-1.448-.937-.302 0-.385.083-.385.5v1.312c0 .355-.115.563-1.042.563a5.7 5.7 0 0 1-4.448-2.667 11.6 11.6 0 0 1-2.302-4.833c0-.219.083-.417.5-.417h1.459c.375 0 .51.167.656.552.708 2.084 1.916 3.896 2.406 3.896.188 0 .27-.083.27-.552v-2.146c-.062-.979-.582-1.062-.582-1.416a.36.36 0 0 1 .374-.334h2.292c.313 0 .417.156.417.531v2.896c0 .313.135.417.229.417.188 0 .333-.104.677-.448a12 12 0 0 0 1.792-2.98.63.63 0 0 1 .635-.416h1.459c.437 0 .53.219.437.531a18.2 18.2 0 0 1-1.958 3.365c-.157.24-.22.365 0 .646.145.219.656.646 1 1.052a6.5 6.5 0 0 1 1.229 1.708c.125.406-.084.615-.5.615" />
  </svg>
);
export default SvgVk;
